import { render, staticRenderFns } from "./notification-centre.vue?vue&type=template&id=96a3474a&scoped=true&"
import script from "./notification-centre.vue?vue&type=script&lang=js&"
export * from "./notification-centre.vue?vue&type=script&lang=js&"
import style0 from "./notification-centre.vue?vue&type=style&index=0&id=96a3474a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a3474a",
  null
  
)

export default component.exports